module.exports = __webpack_public_path__ + "static/media/modelX.e6fa8057.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modelX.jpg
// module id = 499
// module chunks = 33